import { CommonGameEvent } from "@lib/titan2/dist/game/controller/event/CommonGameEvent";
import { ViewUtils } from "@lib/titan2/dist/util/view/ViewUtils";
import { ScatterPickEvent } from "../../../../controller/event/GameEvent";
import { AbstractCameraRig } from "./AbstractCameraRig";
import { ScatterPickIntroCameraRig } from "./ScatterPickIntroCameraRig";
import { ScatterPickOutroCameraRig } from "./ScatterPickOutroCameraRig";
import { ScatterPickTapCameraRig } from "./ScatterPickTapCameraRig";
/**
 * Controls the camera rigging for the game's features.
 */
export class FeatureCameraRig extends AbstractCameraRig {
    create() {
        super.create();
        this.camera = ViewUtils.createContainer(this, "camera");
        this.scatterPickIntro = new ScatterPickIntroCameraRig(this.factory, this.landscapeProperties, this.portraitProperties);
        this.scatterPickTap = new ScatterPickTapCameraRig(this.factory, this.landscapeProperties, this.portraitProperties);
        this.scatterPickOutro = new ScatterPickOutroCameraRig(this.factory, this.landscapeProperties, this.portraitProperties);
        this.addChild(this.scatterPickIntro, this.scatterPickTap, this.scatterPickOutro);
    }
    addEventListeners() {
        super.addEventListeners();
        this.registerGame(CommonGameEvent.RECOVERY, this.handleRecovery);
        this.registerGame(CommonGameEvent.PURCHASE_ENTRY, this.handlePurchaseEntry);
        this.registerGame(ScatterPickEvent.TRANSITION_IN, this.handlePickTransitionIn);
        this.registerGame(ScatterPickEvent.PICK_RESPONSE, this.handlePickResponse);
        this.registerGame(ScatterPickEvent.PICK_RESULT, this.handlePickResult);
        this.registerGame(ScatterPickEvent.TRANSITION_OUT, this.handlePickTransitionOut);
    }
    handleRecovery() {
        this.camera.setParent(this);
    }
    handlePurchaseEntry() {
        this.camera.setParent(this);
    }
    async handlePickTransitionIn() {
        this.camera.setParent(this.scatterPickIntro);
        await this.scatterPickIntro.playIntro();
    }
    async handlePickResponse() {
        this.camera.setParent(this.scatterPickTap);
        await this.scatterPickTap.playTap();
    }
    async handlePickResult() {
        this.camera.setParent(this.scatterPickOutro);
        await this.scatterPickOutro.playOutro();
    }
    handlePickTransitionOut() {
        this.camera.setParent(this);
    }
    addFeature(...view) {
        this.camera.addChild(...view);
    }
}
//# sourceMappingURL=FeatureCameraRig.js.map